module.exports = __webpack_public_path__ + "static/media/call_audio_on.aefe14b1.svg";